import { cartActions } from "modules/cart";

import type { ReqAddToCartProduct } from "modules/cart";
import type { ticketState } from "modules/ticket";
import type { useDispatch } from "react-redux";

type Input = {
  dispatch: ReturnType<typeof useDispatch>;
  eventId: string;
  maybeSelectedGoods: ticketState["eventGoods"][number] | undefined;
  variantAmount: number;
};
type Output = () => void;
type GetHandleAddToCart = (input: Input) => Output;

export const getHandleAddToCart: GetHandleAddToCart = (input) => {
  const { dispatch, eventId, maybeSelectedGoods, variantAmount } = input;
  const handleAddToCart: Output = () => {
    if (maybeSelectedGoods === undefined) return;
    const {
      _id: id = "",
      name,
      price_jpy: price,
      subClassName,
    } = maybeSelectedGoods;
    const targetVariant: ReqAddToCartProduct = {
      count: variantAmount,
      id,
      name,
      price,
      productType: "goods",
      variantName: subClassName,
    };
    dispatch(
      cartActions.addToCart.started({
        body: {
          eventId,
          products: [targetVariant],
        },
        actionOnModal: () =>
          // TODO: 新デザイン用の action を定義して置き換える https://github.com/balus-co-ltd/spwn/issues/11448
          dispatch(cartActions.toggleMyCart({ isOpen: true })),
      })
    );
  };

  return handleAddToCart;
};
